// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3CaS-","title":"ClientInsurance_title__1nT6Z","itemText":"ClientInsurance_itemText__3DcA_"};